/**
 * src/components/layout/AppShell.tsx
 * Master app shell layout coordinating Navbar, BottomDock, and page viewport
 */

import React from 'react';
import { Navbar } from './Navbar';
import { BottomDock } from './BottomDock';

interface AppShellProps {
  children: React.ReactNode;
  currentTab: string;
  onTabChange: (tab: string) => void;
  onNewEntryClick: () => void;
  pendingApprovalsCount?: number;
}

export const AppShell: React.FC<AppShellProps> = ({
  children,
  currentTab,
  onTabChange,
  onNewEntryClick,
  pendingApprovalsCount = 0
}) => {
  return (
    <div className="ambient-background app-viewport-container">
      {/* Top Navbar */}
      <Navbar
        currentTab={currentTab}
        onTabChange={onTabChange}
        pendingApprovalsCount={pendingApprovalsCount}
      />

      {/* Main Viewport Content */}
      <main
        style={{
          flex: 1,
          paddingTop: '24px',
          paddingBottom: '100px', // Extra space so floating mobile dock never obstructs content
          width: '100%'
        }}
      >
        <div className="container">
          {children}
        </div>
      </main>

      {/* Mobile Floating Bottom Navigation Dock */}
      <BottomDock
        currentTab={currentTab}
        onTabChange={onTabChange}
        onNewEntryClick={onNewEntryClick}
        pendingApprovalsCount={pendingApprovalsCount}
      />
    </div>
  );
};
